import { RequestLog } from "../../../models/logging/requestLog";

export const requestLogMapper = (request: Request) => {
  return {
    cache: request.cache as string,
    credentials: request.credentials as string,
    destination: request.destination as string,
    integrity: request.integrity,
    keepalive: request.keepalive,
    method: request.method,
    mode: request.mode as string,
    redirect: request.redirect as string,
    referrer: request.referrer,
    referrerPolicy: request.referrerPolicy as string,
    url: request.url as string,
  } as RequestLog;
};
